import React, { useState, useEffect, useCallback } from 'react';
import { Provider as VariablesProvider } from '../context/variables.context';

/**
 * http://localhost:1234/test/act-2?host=Landbot.io&logo=https%3A%2F%2Fassets.website-files.com%2F5e1c4fb5db4d5243c0021d34%2F5e44008b56790b3d421bfb07_landbot-icon.png
 */
export default function VariablesService(props) {
  const [variables, setVariables] = useState(getURLParams());

  const setVariable = useCallback(
    (key, value) => {
      setVariables((state) => ({
        ...state,
       [key]: value,
      }));
    },
    [variables]
  );

  useEffect(() => {
    window.__variables = variables;
    window.__setVariable = setVariable;
  }, [variables, setVariable]);

  return (
    <VariablesProvider value={{ variables, setVariable }}>
      {props.children}
    </VariablesProvider>
  );
}

function getURLParams() {
  const _queryParams = new URLSearchParams(window.location.search);
  const _params = {};
  for (const [key, value] of _queryParams.entries()) {
    _params[key] = value;
  }
  return _params;
}
